import React, { useContext } from 'react';
import Button from './common/Button';
import appLogo from '../assets/Apps.svg';
import { useHistory } from 'react-router-dom';

const FiuConsentCard = ({
    consent,
    isSelected,
    onSelect,
    onViewDetails,
    customDetails,
    fiuParam,
    selectedAccounts,
    mobileNumber,
}) => {
    const history = useHistory();

    const dateFormat = (dateString) => {
        if (dateString) {
            let newDate = new Date(dateString);
            let dataArray = newDate.toString().split(' ');
            return `${dataArray[2]} ${dataArray[1]} ${dataArray[3]} ${dataArray[4]}`;
        }
    };
    const handleViewDetails = () => {
        history.push({
            pathname: '/fiu-consent-details',
            state: {
                consent: consent,
                fiuParam: fiuParam,
                selectedAccounts: selectedAccounts,
                number: mobileNumber,
            },
        });
    }

    const getStatusColor = (status) => {
        switch (status) {
            case 'ACTIVE':
                return '#D9F8F4';
            case 'PAUSED':
                return '#FFF8EC';
            default:
                return '#D9DDF';
        }
    };
    return (
        <div className="col-12 mb-2 mt-2">
            <div className="border border-1 border-black rounded-top-3" style={{ padding:'16px 8px 16px 16px', borderRadius:'8px 8px 0 0' }}>
                <div className="row p-2">
                    <div className="col-6">
                        <div className="float-start mt-2 d-flex align-items-center" style={{ gap: '0px', position: 'relative' }}>
                            {consent?.consentDetails?.Accounts?.slice(0, 2).map((account, index) => (
                                <img
                                    key={index}
                                    src={account?.fipLogoUri || appLogo}
                                    style={{ 
                                        width: '32px', 
                                        height: '32px', 
                                        objectFit: 'contain',
                                        marginLeft: index > 0 ? '-10px' : '0',
                                        border: '2px solid white',
                                        borderRadius: '50%',
                                        backgroundColor: 'white',
                                        border: '2px solid #D9D9D9',
                                    }}
                                    alt={`Account ${index + 1}`}
                                />
                            ))}
                            {consent?.consentDetails?.Accounts?.length > 2 && (
                                <div 
                                    style={{ 
                                        width: '32px', 
                                        height: '32px', 
                                        borderRadius: '50%',
                                        color: '#273C89',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: '12px',
                                        fontWeight: '600',
                                        marginLeft: '-5px',
                                        zIndex: 0
                                    }}
                                >
                                    +{consent.consentDetails.Accounts.length - 2}
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="col-6" style={{ alignSelf: 'center' }}>
                        <div className="form-check form-check-inline float-end" onClick={() => onSelect(consent)} style={{ cursor: 'pointer', marginRight: '4px'}}>
                            <div
                                style={{
                                    width: '16px',
                                    height: '16px',
                                    borderRadius: '4px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    backgroundColor: isSelected ? (customDetails?.primaryBtnColor || '#273C89') : 'white',
                                    border: isSelected ? '2px solid #273C89' : '2px solid #727272',
                                }}
                            >
                                {isSelected && (
                                    <svg width="12" height="10" viewBox="0 0 12 10" fill="none">
                                        <path d="M1 5L4.5 8.5L11 1.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row p-2">
                    <div className="col-9">
                        <p className="fs-14 fw-500 text-black text-start" style={{ color: '#111111', marginBottom: '0' }}>
                            {consent?.consentPurposeText}
                        </p>
                    </div>
                    <div className="col-3 d-flex justify-content-end align-items-start">
                        <div 
                            className="d-inline-block px-2 py-1 rounded" 
                            style={{ 
                                backgroundColor: getStatusColor(consent?.status),
                                fontSize: '10px',
                                fontWeight: '600',
                                color: consent?.status === 'ACTIVE' ? '#00A389' : 
                                       consent?.status === 'PAUSED' ? '#FF9900' : '#111111'
                            }}
                        >
                            {consent?.status}
                        </div>
                    </div>
                    <div className="row p-2 mt-auto">
                        <div className="col-7">
                            <p
                                className="fs-14 fw-500 text-start"
                                style={{ marginBottom:'0', color: '#6C6C6C' }}
                            >
                                Consent given for {consent?.consentDetails?.Accounts?.length || 0} Account(s)
                            </p>
                        </div>
                        <div className="col-5 d-flex justify-content-end p-0">
                            <Button
                                className="fs-14 fw-400 bg-transparent border-0 rounded-3 p-0"
                                style={{ color: '#273C89', textDecoration:'underline' }}
                                onClick={handleViewDetails}
                            >
                                View Details
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="border-black rounded-bottom-3" style={{ backgroundColor: '#F6F6F6', padding:'0 14px', borderRadius:'0 0 8px 8px', borderWidth: '0 1px 1px 1px', borderStyle: 'solid', borderColor: '#D9D9D9' }}>
                <p className="fs-12 fw-400 text-start mb-0" style={{ color: '#6C6C6C', padding:'14px 0', borderRadius:'8px' }}>
                    Issued on {dateFormat(consent?.consentIntentUpdateTimestamp)}
                </p>
            </div>
        </div>
    );
};

export default FiuConsentCard;
